<script>
import { useDynamicUgcStore } from "~/stores/dynamic-ugc-store";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "PublishArticleButton",
  elementPanelSettings: {
    displayName: "Publish Article Button",
    elementGroup: "articleElements",
  },
  extends: BaseButtonElement,
  methods: {
    handleButtonClick() {
      return this.editMode ? null : useDynamicUgcStore().publishArticle();
    },
  },
};
</script>
